import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconCheckmark } from '@noths/polaris-client-ribbons-design-system';
import { Price } from "../Price/Price";
import * as styles from "./Check.styles";
export var Check = function Check(_ref) {
  var currency = _ref.currency,
    isSelected = _ref.isSelected,
    label = _ref.label,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    price = _ref.price;
  return /*#__PURE__*/React.createElement(_StyledButton, {
    "aria-pressed": isSelected,
    onClick: onClick,
    onFocus: onFocus,
    type: "button",
    $_css: styles.button
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: styles.checkWrapper
  }, /*#__PURE__*/React.createElement(_StyledIconCheckmark, {
    color: "var(--brand-purple-base)",
    dataAttributes: {
      'is-selected': String(isSelected)
    },
    $_css3: styles.checkmark
  }), /*#__PURE__*/React.createElement(_StyledSpan, {
    dangerouslySetInnerHTML: {
      __html: label
    },
    "data-is-selected": isSelected,
    $_css4: styles.label
  })), /*#__PURE__*/React.createElement(Price, {
    currency: currency,
    price: price
  }));
};
var _StyledButton = _styled("button")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconCheckmark = _styled3(IconCheckmark)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledSpan = /*#__PURE__*/_styled4("span").withConfig({
  displayName: "Check___StyledSpan",
  componentId: "sc-14dpxby-0"
})(["", ""], function (p) {
  return p.$_css4;
});